import { getBrowserWidthBucket } from 'owa-layout';

export function getIsNarrowFullCompose() {
    return getBrowserWidthBucket() <= 1079;
}
